import { makeStyles } from '@material-ui/core/styles';

export  const useStyles = makeStyles(theme => ({
    formControl:{
        minWidth: 300,
        paddingRight: theme.spacing(2),
    },

    inputAdornment:{
        color: "#5a5a5a"
    }
}));